import { ChatTheme } from "../types";

export const defaultTheme: ChatTheme = {
  // Main colors
  primary: "#4F46E5", // Indigo-600
  secondary: "#6366F1", // Indigo-500
  background: "#FFFFFF",
  textPrimary: "#1F2937", // Gray-800
  textSecondary: "#4B5563", // Gray-600

  // Message bubbles
  userBubbleBackground: "#4F46E5", // Indigo-600
  userBubbleText: "#FFFFFF",
  botBubbleBackground: "#F3F4F6", // Gray-100
  botBubbleText: "#1F2937", // Gray-800
  systemMessageColor: "#9CA3AF", // Gray-400

  // Header
  headerBackground: "#4F46E5", // Indigo-600
  headerText: "#FFFFFF",

  // Input
  inputBackground: "#FFFFFF",
  inputFieldBackground: "#F9FAFB", // Gray-50
  inputTextColor: "#1F2937", // Gray-800
  inputBorderColor: "#E5E7EB", // Gray-200

  // Misc
  borderColor: "#E5E7EB", // Gray-200
  timestampColor: "#9CA3AF", // Gray-400
  errorColor: "#EF4444", // Red-500
  successColor: "#10B981", // Green-500

  // Typography
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  fontSize: "14px",
  fontSizeSmall: "12px",
  fontSizeLarge: "16px",

  // Spacing
  spacing: {
    unit: 4,
    tiny: "4px",
    small: "8px",
    medium: "16px",
    large: "24px",
    extraLarge: "32px",
  },

  // Border radius
  borderRadius: {
    small: "4px",
    medium: "8px",
    large: "16px",
    circle: "50%",
  },

  // Box shadow
  boxShadow: {
    light: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    medium:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    heavy:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  },

  // Animations
  animations: {
    transitionDuration: "200ms",
    easing: "ease-in-out",
  },
};

export const darkTheme: ChatTheme = {
  ...defaultTheme,
  // Main colors
  primary: "#6366F1", // Indigo-500
  secondary: "#818CF8", // Indigo-400
  background: "#1F2937", // Gray-800
  textPrimary: "#F9FAFB", // Gray-50
  textSecondary: "#E5E7EB", // Gray-200

  // Message bubbles
  userBubbleBackground: "#6366F1", // Indigo-500
  userBubbleText: "#FFFFFF",
  botBubbleBackground: "#374151", // Gray-700
  botBubbleText: "#F9FAFB", // Gray-50

  // Header
  headerBackground: "#6366F1", // Indigo-500
  headerText: "#FFFFFF",

  // Input
  inputBackground: "#1F2937", // Gray-800
  inputFieldBackground: "#374151", // Gray-700
  inputTextColor: "#F9FAFB", // Gray-50
  inputBorderColor: "#4B5563", // Gray-600

  // Misc
  borderColor: "#4B5563", // Gray-600
  timestampColor: "#9CA3AF", // Gray-400
};
